import {
  fileResources,
  notification,
  projects,
  userPaymentTransfersResponse,
} from "../types/apiResponse";
import { APIBASEURL } from "../consts/common";
import axios from "axios";
import { ProjectStore } from "../store/ProjectStore";
import { useStore } from "../store/SessionLiffStore";
import { CommonStore } from "../store/CommonStore";
import * as Sentry from "@sentry/vue";

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;
axios.defaults.headers.common["x-api-key"] =
  "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4";

axios.defaults.headers.common["AxiosAccess-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Content-Type"] = "application/json";

// 案件一覧取得
export const getApi = async (media_type: number) => {
  const projectStore = ProjectStore();
  const commonStore = CommonStore();
  const liff = useStore();
  try {
    const res = await axios.get(APIBASEURL + "projects", {
      params: {
        sns: media_type,
        page: projectStore.projectListPageNum[media_type],
        line_user_id: liff.lineUserId,
      },
    });
    return JSON.parse(JSON.stringify(res.data.data)) || [];
  } catch (e) {
    console.error(e);
    commonStore.setToast({
      showToast: true,
      message: "アクセスが集中しております。時間をおいて再度お試しください。",
      state: 1,
      timeout: 2000,
    });
    return [];
  }
};
// 応募中タブ一覧取得
export const getAppliedProjects = async (
  state: number[],
  page: number
): Promise<projects[]> => {
  try {
    const liff = useStore();
    const res = await axios.get(APIBASEURL + "projects", {
      params: {
        application_state: state,
        page: page,
        line_user_id: liff.lineUserId,
      },
    });
    return JSON.parse(JSON.stringify(res.data.data));
  } catch (e) {
    console.error(e);
    return [];
  }
};
// 三条書面一覧取得
export const getDocumentProjects = async (
  state: number[],
  page: number
): Promise<projects[]> => {
  try {
    const liff = useStore();
    const res = await axios.get(APIBASEURL + "projects", {
      params: {
        application_state: state,
        page: page,
        line_user_id: liff.lineUserId,
      },
    });
    return JSON.parse(JSON.stringify(res.data.data));
  } catch (e) {
    console.error(e);
    return [];
  }
};
// 案件詳細
export const getProjectDetail = async (
  _selected_project_id: number
): Promise<projects | undefined> => {
  const liff = useStore();
  return await axios
    .get(APIBASEURL + `projects/${_selected_project_id}`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      return JSON.parse(JSON.stringify(res.data.data));
    });
};

// 応募
export const applyProject = async (
  _selected_project_id: number
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  let result = false;
  let messsage = "";
  let state = 0;
  const liff = useStore();

  await axios
    .get(APIBASEURL + `projects/${_selected_project_id}/apply`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = res.status == 200;
      messsage = "";
      state = 0;
      // if (res.status != 200) {
      //   return false;
      // } else return true;
    })
    .catch((e) => {
      result = false;
      messsage = e.data.error ? e.data.error.message : "案件応募に失敗しました";
      state = 1;
      // return false;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};

// 応募キャンセル
export const cancelProject = async (
  _selected_project_id: number
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  let result = false;
  let messsage = "";
  let state = 0;
  const liff = useStore();

  await axios
    .get(APIBASEURL + `projects/${_selected_project_id}/cancel`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = res.status == 200;
      messsage = "";
      state = 0;
    })
    .catch((e) => {
      result = false;
      messsage = e.data.error
        ? e.data.error.message
        : "応募のキャンセルに失敗しました";
      state = 1;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};

// お気に入り一覧
export const getFavoriteProjects = async (
  page?: number
): Promise<projects[]> => {
  let result: projects[] = [];
  const projectStore = ProjectStore();
  const liff = useStore();
  await axios
    .get(APIBASEURL + `favorites`, {
      params: {
        page: page ? page : projectStore.favoritePageNum,
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = JSON.parse(JSON.stringify(res.data.data));
    });
  return result;
};

// お気に入り追加
export const addFavoriteProject = async (
  projectId: number
): Promise<boolean> => {
  let result: boolean = false;
  const liff = useStore();
  await axios
    .post(APIBASEURL + `projects/${projectId}/favorites`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = JSON.parse(JSON.stringify(res.data.status));
    });
  return result;
};

// お気に入り解除
export const deleteFavoriteProject = async (
  projectId: number
): Promise<boolean> => {
  let result: boolean = false;
  const liff = useStore();
  await axios
    .delete(APIBASEURL + `projects/${projectId}/favorites`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = JSON.parse(JSON.stringify(res.data.status));
    });
  return result;
};

//ファイルアップロード
export const uploadResource = async (
  data: FormData,
  _selected_project_id: number
): Promise<fileResources> => {
  const liff = useStore();
  axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let result!: fileResources;
  await axios
    .post(
      APIBASEURL + `projects/${_selected_project_id}/upload_resource`,
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
        params: {
          line_user_id: liff.lineUserId,
        },
      }
    )
    .then((res) => {
      result = JSON.parse(JSON.stringify(res.data.data));
    })
    .catch((e) => {
      Sentry.captureMessage("下書きアップロードエラー発生！！！！", e);
    });
  return result;
};

// 下書き送信
export const sendDraft = async (
  data: { content: string; resources: number[]; url: string },
  _selected_project_id: number
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  const liff = useStore();
  let result = false;
  let messsage = "";
  let state = 0;
  await axios
    .post(APIBASEURL + `projects/${_selected_project_id}/submit_draft`, {
      ...data,
      line_user_id: liff.lineUserId,
    })
    .then((res) => {
      result = res.data.status == 200;
      // result = JSON.parse(JSON.stringify(res.data.status)) == 200;
    })
    .catch((e) => {
      result = false;
      messsage = e.data.error
        ? e.data.error.message
        : "下書き送信に失敗しました";
      state = 1;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};

// 商品受け取り完了
export const receiveProduct = async (
  _selected_project_id: number
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  let result = false;
  let messsage = "";
  let state = 0;
  const liff = useStore();
  await axios
    .post(APIBASEURL + `projects/${_selected_project_id}/receive_product`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-api-key":
          "0418bfff8757bd6410aca59f6899d1e35b23b4d3759654fbb7af9dbf8a1aa8d4",
        "Access-Control-Allow-Origin": "*",
      },
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      result = res.data.status == 200;
    })
    .catch((e) => {
      result = false;
      messsage = e.data.error
        ? e.data.error.message
        : "ステータスの更新に失敗しました";
      state = 1;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};

// 案件投稿完了
export const submitPost = async (
  _selected_project_id: number,
  param?: { url: string }
): Promise<{
  result: boolean;
  message: string;
  state: number;
}> => {
  let result = false;
  let messsage = "";
  let state = 0;
  const liff = useStore();

  await axios
    .post(APIBASEURL + `projects/${_selected_project_id}/submit_post`, {
      ...param,
      line_user_id: liff.lineUserId,
    })
    .then((res) => {
      result = res.data.status == 200;
    })
    .catch((e) => {
      result = false;
      messsage = e.data.error
        ? e.data.error.message
        : "下書きの送信に失敗しました";
      state = 1;
    });
  return {
    result: result,
    message: messsage,
    state: state,
  };
};

// 案件通知
export const getNotification = async (): Promise<notification | undefined> => {
  const liff = useStore();
  return await axios
    .get(APIBASEURL + `notification`, {
      params: {
        line_user_id: liff.lineUserId,
      },
    })
    .then((res) => {
      return JSON.parse(JSON.stringify(res.data.data));
    })
    .catch(() => {
      return undefined;
    });
};
// 案件通知既読
export const readNotification = async (req: {
  step: number;
}): Promise<notification | undefined> => {
  const liff = useStore();
  return await axios
    .post(APIBASEURL + `notification/read`, {
      ...req,
      line_user_id: liff.lineUserId,
    })
    .then((res) => {
      return JSON.parse(JSON.stringify(res.data.data));
    })
    .catch(() => {
      return undefined;
    });
};
// お問い合わせ内容を管理画面側にも送信する
export const messages = async (req: { message: string }): Promise<string> => {
  const liff = useStore();
  return await axios
    .post(APIBASEURL + `messages`, { ...req, line_user_id: liff.lineUserId })
    .then((res) => {
      return JSON.parse(JSON.stringify(res.status));
    })
    .catch(() => {
      return 200;
    });
};
// 支払通知書一覧
export const userPaymentTransfers = async (): Promise<
  userPaymentTransfersResponse[] | []
> => {
  return await axios
    .get(APIBASEURL + `user_payment_transfers`)
    .then((res) => {
      return JSON.parse(JSON.stringify(res.data.data));
    })
    .catch(() => {
      return [];
    });
};
